import * as d3 from 'd3'
export default {
  methods: {

    draw_Diagram() {

      let parent = this.config.parent

      let process = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, 0)`)

      let last = 0
      this.stages.filter(f=> f.NAME).forEach((d,i)=> {

        let store = process
        .append('g')
        .attr('transform', `translate(${this.config.x[i]}, ${this.config.y})`)

        this.draw_Stage(store, d, i)
        // Arrow
        if(this.stages[i+1]) {
          let x_ = this.config.x[i] + this.getNode(`#STAGE_BOX_${i}`)
          let y_ = this.config.y + parent.height/2
          let width_ = this.config.x[i+1] - x_ - 8

          process
          .append('path')
          .attr('transform', `translate(${x_ + width_}, ${y_ - 4})`)
          .attr('d', 'M0 0 L8 4 L0 8 L0 0 Z').attr('fill', '#bcbcbc')

          this.gmx_Line(process, x_, x_ + width_, y_, y_, '#bcbcbc', 2, 1)
        }

        let data = this.rawData.filter(f=> f.STG_IDX == d.IDX)
        this.child_InputList( d, data.filter(f=> f.RELATION == 'Input'))
        this.child_ExecList(  d, data.filter(f=> f.RELATION == 'Exec'))
        this.child_OutputList(d, data.filter(f=> f.RELATION == 'Output'))
        last = i
      })

      let codi = this.stages.filter(f=> f.NAME)[last]

      // CUTOFF
      let calender = process
      .append('g')
      .attr('transform', `translate(${codi.ex + 230}, ${this.config.y - 150})`)
      .call(this.exec_Procedure, 'CUTOFF')

      let updated = this.diagram && this.diagram.CUTOFF_DATE ? new Date(this.diagram.CUTOFF_DATE) : null

      calender
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Calender.svg`).attr('width', 80)

      calender
      .append('text')
      .attr('id', 'CUTOFF_MONTH')
      .attr('x', 40).attr('y', 17)
      .attr('fill', '#fff').attr('font-size', 10).attr('text-anchor', 'middle')
      .text(updated ? updated.toLocaleString('en-US', { month: 'long' }) : '')

      calender
      .append('text')
      .attr('id', 'CUTOFF_DAY')
      .attr('x', 40).attr('y', 49)
      .attr('fill', '#757575').attr('font-size', 26).attr('text-anchor', 'middle')
      .text(updated ? updated.getDate() : '')

      calender
      .append('text')
      .attr('id', 'CUTOFF_DATE')
      .attr('x', 43).attr('y', 95)
      .attr('fill', '#EC407A').attr('font-size', 12).attr('text-anchor', 'middle')
      .text(`${this.diagram && this.diagram.CUTOFF_CODE ? this.diagram.CUTOFF_CODE : ''}`)


      // VERIFY
      let verify = process
      .append('g')
      .attr('transform', `translate(${codi.ex + 230}, ${this.config.y - 0})`)
      .call(this.exec_Procedure, 'VERIFY')

      verify
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Verify.svg`).attr('width', 80)

      verify
      .append('text')
      .attr('id', 'VERIFY_MODAL')
      .attr('x', 43).attr('y', 95)
      .attr('fill', '#EC407A').attr('font-size', 11).attr('text-anchor', 'middle')
      .text(`${this.diagram && this.diagram.VERIFY_MODAL ? this.diagram.VERIFY_MODAL : ''}`)


      // DEV SERVER
      let dev = process
      .append('g')
      .attr('transform', `translate(${codi.ex + 230}, ${this.config.y + 150})`)
      .call(this.exec_Procedure, 'DEV')

      dev
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Dev.svg`).attr('width', 80)

      dev
      .append('text')
      .attr('id', 'DEV_PROCEDURE')
      .attr('x', 41).attr('y', 95)
      .attr('fill', '#EC407A').attr('font-size', 11).attr('text-anchor', 'middle')
      .text(`${this.diagram && this.diagram.DEV_PROCEDURE ? this.diagram.DEV_PROCEDURE : ''}`)


      // SERVICE SERVER
      let service = process
      .append('g')
      .attr('transform', `translate(${codi.ex + 230}, ${this.config.y + 300})`)
      .call(this.exec_Procedure, 'SERVICE')

      service
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Service.svg`).attr('width', 80)

      service
      .append('text')
      .attr('id', 'SVS_PROCEDURE')
      .attr('x', 43).attr('y', 95)
      .attr('fill', '#EC407A').attr('font-size', 11).attr('text-anchor', 'middle')
      .text(`${this.diagram && this.diagram.SVS_PROCEDURE ? this.diagram.SVS_PROCEDURE : ''}`)
      
      this.diagram_Coloring() // -----> diagram_Actions.js
    },

  }
}